import { render } from "./CourseManager.vue?vue&type=template&id=44a8c10e&scoped=true"
import script from "./CourseManager.vue?vue&type=script&lang=js"
export * from "./CourseManager.vue?vue&type=script&lang=js"

import "./CourseManager.vue?vue&type=style&index=0&id=44a8c10e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a8c10e"]])

export default __exports__